import React from 'react';
import axios from 'axios';

// class API {
//     constructor() {
//     }
// }
// export function getAllUsers (){
//     const response  = axios.get(`https://us-central1-body-f1rst-dev.cloudfunctions.net/api/getAllUsers`)
//     return response;
// } 
// export function get(){
//     axios.get(`https://us-central1-body-f1rst-dev.cloudfunctions.net/api/getAllUsers`);
// } 
export default axios.create({
    baseURL: "https://us-central1-body-f1rst-dev.cloudfunctions.net/api/",
    responseType: "json"
  });
//export default API;
